import React, {useState,useEffect, useRef} from 'react';
import { connect } from 'react-redux';
import { redirect, useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import DropDownMenu from '../components/DropDownMenu';
import FileDropzone from './components/UploadFileDropZone';
import RemoveSvg from '../../svg/admin/Remove';
import AddSvg from '../../svg/admin/Add';
import MDEditor from '@uiw/react-md-editor';
import _, { wrap } from 'lodash';
import { HexColorPicker } from "react-colorful";
import { uploadPhoto } from '../../services2/s3.service';
import PopupWindow from './components/TextPopupWindow';

function Component(props) {
  const data=props.data||{};
  const navigate = useNavigate();
  const [isLoading,setisLoading]=useState(false)

  const handleUpdateField=(field)=>(e)=>{
    props.onEdit(field,e.target.value)
  }

  useEffect(() => {

  },[])






  {/*handle File upload*/}
  const handleContentFileUpload=(item,index)=>async(files)=>{
    if(files.length>1){
        alert(`Only one file is allowed.`)
        return
    }
    const file= files[0]
    if(!['image/png','image/jpeg','image/gif'].includes(file.type)){
        alert(`File type ${file.type} is not allowed`)
        return
    }
    if(file.size>1024*1024*2){
        alert(`File size must be within 2 MB`)
        return
    }

    let formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('json', JSON.stringify({}));
    setisLoading(true);
    let res = await uploadPhoto(props.token?.token,formData,props.id,`${props.data.id}_${item?.id}`)
    if(res.errno){
        alert(res.message)
    }else{
        if(res.result){
            let filepath=res.result
            if(props.onEdit)props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,photo:filepath}:c))
        }
    }
    setisLoading(false);
  }
  const handleRemoveContentImage=(item,index)=>async()=>{
    if(props.onEdit)props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,photo:''}:c))
  }
  const onDropImageFile = async (files) =>{
    if(files.length>1){
        alert(`Only one file is allowed.`)
        return
    }
    const file= files[0]
    if(!['image/png','image/jpeg','image/gif'].includes(file.type)){
        alert(`File type ${file.type} is not allowed`)
        return
    }
    if(file.size>1024*1024*2){
        alert(`File size must be within 2 MB`)
        return
    }

    let formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('json', JSON.stringify({}));
    setisLoading(true);
    let res = await uploadPhoto(props.token?.token,formData,props.id,`${props.data.id}_icon`)
    if(res.errno){
        alert(res.message)
    }else{
        if(res.result){
            let filepath=res.result
            if(props.onEdit)props.onEdit('icon',filepath)
        }
    }
    setisLoading(false);
  }
  const handleRemoveImage = async() =>{
    setisLoading(true);
    if(props.onEdit)props.onEdit('icon','')
    setisLoading(false);
  }
  {/*end of handle File upload*/}

  const redirectRef=useRef([])
  useEffect(() => {
    redirectRef.current = redirectRef.current.slice(0, data?.contents?.length||1);
  },[data.contents])

  {/*handle popup window*/}
  const [isShowPopup,setisShowPopup]=useState(false)


  return (
    <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{overflowY:"auto"}}>
        {/*buttons*/}
        <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
            <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={()=>{if(props.close)props.close()}}>{`<`} 返回</div>
            <div className='flex flex-row gap-[8px] flex-wrap '>
                {/* <div className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{border:'1px solid #1F4CC8'}}>刪除</div>
                <div className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{border:'1px solid #1F4CC8'}}>複製</div> */}
                <div onClick={()=>{if(props.onSave)props.onSave()}} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{border:'1px solid #1F4CC8'}}>儲存</div>
            </div>
        </div>
        {/*end of buttons*/}

        <div className='font-[400] text-[#43528A] text-[24px] '>{props.title}</div>

        <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap'>
            <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
                <div className='font-[700]'>頁面標題</div>
                <input value={data?.name} onChange={handleUpdateField('name')} placeholder='頁面標題' className='rounded-[7px] px-[8px] py-[4px] font-[400]'/>
                <div className='font-[700]'>url</div>
                <input value={data?.url} onChange={handleUpdateField('url')} placeholder='頁面標題' className='rounded-[7px] px-[8px] py-[4px] font-[400]'/>
            </div>

            <div className='flex-[2] flex flex-col min-w-[300px] gap-[8px]'>
                <div className='font-[700]'>Icon</div>
                {data?.icon&&<div className='relative w-full'>
                  {
                      data?.icon
                      ?<img style={{height:50,width:50,objectFit:'contain'}} src={data?.icon} alt='image'/>
                      :<div></div>
                  }
                  <div onClick={handleRemoveImage} className='cursor-pointer' style={{position:'absolute',top:5,right:5}}>
                      <RemoveSvg/>
                  </div>
                </div>}
                <div className='w-full' style={{height:170,backgroundColor:'white',border:'1px solid #E5E5E5'}}>
                    <FileDropzone onDropFile={onDropImageFile}  data={data}/>
                </div>
            </div>
        </div>

        {/* <div className='flex flex-col w-full gap-[8px]'>
            <div className='font-[700]'>頁面模板</div>
            <div className='w-full flex flex-col'>
                <DropDownMenu
                    select={(value)=>{props.onEdit('template',value)}}
                    value={data?.template||"-"}
                    options={['PISA 模板 1']}
                />
            </div>
        </div> */}

        <div className='font-[700] w-full text-center mt-[16px]'>頁面內容</div>

        <div className='w-full flex flex-col p-[16px] gap-[8px] bg-[#E9E9E9] rounded-[7px]'>
            {data?.contents?.map((item,index)=>
                <div key={index} className='w-full flex flex-col p-[8px] rounded-[7px] gap-[8px]' style={{border:'1px dashed #00000066'}}>
                    <div className='w-full flex flex-row justify-center relative'>
                        <DropDownMenu 
                            minWidth={250}
                            select={(value)=>{props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,type:value}:c))}}
                            value={item?.type||"text"}
                            options={[
                                '文章標題(左對齊)','文章標題(居中對齊)','文章標題(右對齊)',
                                '閱讀文章內容(左對齊)','閱讀文章內容(居中對齊)','閱讀文章內容(右對齊)',
                                '圖片','超連結','彈出視窗'
                            ]}
                        />
                        <div onClick={()=>{
                            if(props.onEdit)props.onEdit('contents',data?.contents?.filter((c,i)=>i!==index))
                        }} className='cursor-pointer' style={{position:'absolute',top:5,right:5}}>
                            <RemoveSvg/>
                        </div>
                    </div>
                    <div className='flex flex-col w-full gap-[8px]'>
                        <div className='flex flex-row items-center gap-[16px] font-[700]'>
                            <div>背景顏色: {item?.backgroundColor||'#ffffff'}</div>
                            <HexColorPicker color={item?.backgroundColor||'#ffffff'} onChange={(color)=>{
                                props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,backgroundColor:color}:c))
                            }} />
                            <div className='ml-[24px]'>文字顏色: {item?.color||'#000000'}</div>
                            <HexColorPicker color={item?.color||'#000000'} onChange={(color)=>{
                                props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,color:color}:c))
                            }} />
                        </div>
                    </div>
                    {item?.type?.includes('文章標題')&&<div className='flex flex-col w-full gap-[8px]'>
                        <MDEditor
                            data-color-mode="light"
                            className='bg-white'
                            value={item?.text}
                            onChange={(v)=>{props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,text:v}:c))}}
                        />
                        <div className='font-[700]'>預覽</div>
                        <div className={`p-[16px] font-[700]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:item.type==='文章標題(左對齊)'?'left':item.type==='文章標題(居中對齊)'?'center':'right'}}>
                            <MDEditor.Markdown wrapperElement={{"data-color-mode": "light"}} source={item?.text||''} style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent",fontSize:32}} />
                        </div>
                    </div>}
                    {item?.type?.includes('閱讀文章內容')&&<div className='flex flex-col w-full gap-[8px]'>
                        <MDEditor
                            data-color-mode="light"
                            className='bg-white'
                            value={item?.text}
                            onChange={(v,e)=>{props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,text:v}:c))}}
                        />
                        <div className='font-[700]'>預覽</div>
                        <div className={`p-[16px]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:item.type==='閱讀文章內容(左對齊)'?'left':item.type==='閱讀文章內容(居中對齊)'?'center':'right'}}>
                            <MDEditor.Markdown wrapperElement={{"data-color-mode": "light"}} source={item?.text} style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent"}} />
                        </div>
                    </div>}
                    {item.type==='超連結'&&<div className='flex flex-col w-full gap-[8px]'>
                        <input
                            className='bg-white rounded-[7px] p-[8px]'
                            value={item?.text}
                            placeholder='文字'
                            onChange={(e)=>{props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,text:e.target.value}:c))}}
                            ref={el => redirectRef.current[index] = el} 
                        />
                        <div className='flex flex-col gap-[8px]'>
                            {item?.redirects?.map((r,ri)=>
                                <div key={ri} className='flex flex-row gap-[16px] items-center flex-wrap'>
                                    <div className='font-bold'>#連結 {Number(ri)+1} 文字:</div> 
                                    <div className='text-[blue] cursor-pointer underline'>{item?.text.slice(r?.start,r?.end)}</div>
                                    <div className='font-[700]'>頁面:</div>
                                    <div className=''>
                                        <DropDownMenu options={props.pages?.map(p=>p.name)} value={props.pages?.filter(p=>p.id===r.pageId)?.[0]?.name||'--- 無 ---'} select={(p,pi)=>{
                                                if(props.onEdit)props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,redirects:[
                                                    ...c.redirects.slice(0,ri),
                                                    { ...r,pageId:props.pages[pi].id},
                                                    ...c.redirects.slice(ri+1),
                                                ]}:c))
                                            }}
                                        />
                                    </div>
                                    <div onClick={()=>{
                                        if(props.onEdit)props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,redirects: c.redirects?.filter((r_,ri_)=>ri!==ri_)}:c))
                                    }} className='cursor-pointer' style={{}}>
                                        <RemoveSvg/>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='flex flex-row'>
                            <div
                                onClick={()=>{
                                    if(redirectRef.current[index]?.selectionStart==undefined||redirectRef.current[index]?.selectionEnd===undefined){
                                        alert('請在上面的輸入欄位中選擇文字');return
                                    }if(redirectRef.current[index]?.selectionStart===redirectRef.current[index]?.selectionEnd){
                                        alert('請在上面的輸入欄位中選擇文字');return
                                    }
                                    if(props.onEdit)props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,redirects:[...(c.redirects||[]),
                                        {
                                            start:redirectRef.current[index]?.selectionStart,
                                            end:redirectRef.current[index]?.selectionEnd
                                        }
                                    ]}:c))
                                }}
                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                style={{ border: '1px solid #1F4CC8' }}
                            >
                                <AddSvg /> 超連結
                            </div>
                        </div>
                        <div className='font-[700]'>預覽</div>
                        <div className={`p-[16px]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:'left'}}>
                            <div style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent"}}>
                                <div className='inline' dangerouslySetInnerHTML={{__html: (item.redirects?.[0]?item?.text?.slice(0,item.redirects?.[0]?.start):item?.text)||'' }}/>
                                {item.redirects?.sort( (a,b)=> (a.start>b.start)?1:(a.start<b.start)?-1:0
                                )?.map((r,ri)=>
                                    <div className='inline' key={ri}>
                                        <div className='inline text-[blue] cursor-pointer underline' dangerouslySetInnerHTML={{__html: item?.text.slice(r.start,r.end)}}/>
                                        <div className='inline' dangerouslySetInnerHTML={{__html: 
                                            item.redirects?.[ri+1]?
                                            item?.text.slice(r.end,item.redirects?.[ri+1].start)
                                            :item?.text.slice(r.end)
                                        }}/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>}
                    {item.type==='彈出視窗'&&<div className='flex flex-col w-full gap-[8px]'>
                        <textarea
                            className='bg-white rounded-[7px] p-[8px] min-h-[100px]'
                            value={item?.text}
                            placeholder='文字'
                            onChange={(e)=>{props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,text:e.target.value}:c))}}
                            ref={el => redirectRef.current[index] = el} 
                        />
                        <div className='flex flex-col gap-[8px]'>
                            {item?.popups?.map((r,ri)=>
                                <div key={ri} className='flex flex-row gap-[16px] items-center flex-wrap'>
                                    <div className='font-bold'>#視窗 {Number(ri)+1} 文字:</div> 
                                    <div className='text-[blue] cursor-pointer underline'>{item?.text.slice(r?.start,r?.end)}</div>
                                    <div className='font-[700]'>視窗頁面:</div>
                                    <div className='flex-1'>
                                        {/* <DropDownMenu options={props.pages?.map(p=>p.name)} value={props.pages?.filter(p=>p.id===r.pageId)?.[0]?.name||'--- 無 ---'} select={(p,pi)=>{
                                                if(props.onEdit)props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,popups:[
                                                    ...c.popups.slice(0,ri),
                                                    { ...r,pageId:props.pages[pi].id},
                                                    ...c.popups.slice(ri+1),
                                                ]}:c))
                                            }}
                                        /> */}
                                        <textarea
                                            className='bg-white rounded-[7px] p-[8px] w-full'
                                            value={r.text||""}
                                            placeholder='文字'
                                            onChange={(e)=>{
                                                props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,popups:[
                                                    ...c.popups.slice(0,ri),
                                                    { ...r,text:e.target.value},
                                                    ...c.popups.slice(ri+1),
                                                ]}:c))
                                            }}
                                        />
                                    </div>
                                    <div onClick={()=>{
                                        if(props.onEdit)props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,popups: c.popups?.filter((r_,ri_)=>ri!==ri_)}:c))
                                    }} className='cursor-pointer' style={{}}>
                                        <RemoveSvg/>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='flex flex-row'>
                            <div
                                onClick={()=>{
                                    if(redirectRef.current[index]?.selectionStart==undefined||redirectRef.current[index]?.selectionEnd===undefined){
                                        alert('請在上面的輸入欄位中選擇文字');return
                                    }if(redirectRef.current[index]?.selectionStart===redirectRef.current[index]?.selectionEnd){
                                        alert('請在上面的輸入欄位中選擇文字');return
                                    }
                                    if(props.onEdit)props.onEdit('contents',data?.contents?.map((c,i)=>i===index?{...c,popups:[...(c.popups||[]),
                                        {
                                            start:redirectRef.current[index]?.selectionStart,
                                            end:redirectRef.current[index]?.selectionEnd
                                        }
                                    ]}:c))
                                }}
                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                style={{ border: '1px solid #1F4CC8' }}
                            >
                                <AddSvg /> 彈出視窗
                            </div>
                        </div>
                        <div className='font-[700]'>預覽</div>
                        <div className={`p-[16px]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:'left'}}>
                            <div style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent"}}>
                                <div className='inline' dangerouslySetInnerHTML={{__html: (item.popups?.[0]?item?.text?.slice(0,item.popups?.[0]?.start):item?.text)||'' }}/>
                                {item.popups?.sort( (a,b)=> (a.start>b.start)?1:(a.start<b.start)?-1:0
                                )?.map((r,ri)=>
                                    <div className='inline' key={ri}>
                                        <div className='inline text-[blue] cursor-pointer' style={{textDecoration:item.noUnderline?'none':'underline'}} onClick={()=>{setisShowPopup(r.text)}} dangerouslySetInnerHTML={{__html: item?.text.slice(r.start,r.end)}}/>
                                        <div className='inline' dangerouslySetInnerHTML={{__html: 
                                            item.popups?.[ri+1]?
                                            item?.text.slice(r.end,item.popups?.[ri+1].start)
                                            :item?.text.slice(r.end)
                                        }}/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>}
                    {item?.type==='圖片'&&
                        <div className='w-full flex flex-col'>
                            <div className='w-full' style={{height:170,backgroundColor:'white',border:'1px solid #E5E5E5'}}>
                                <FileDropzone onDropFile={handleContentFileUpload(item,index)} data={item}/>
                            </div>
                            <div className='font-[700]'>預覽</div>
                            {item?.photo&&<div className='relative w-full flex flex-row justify-center p-[16px]' style={{backgroundColor:item?.backgroundColor||'white'}}>
                                {
                                    item?.photo
                                    ?<img style={{height:400,width:400,objectFit:'contain',maxWidth:'100%'}} src={item?.photo} alt='image'/>
                                    :<div></div>
                                }
                                <div onClick={handleRemoveContentImage(item,index)} className='cursor-pointer' style={{position:'absolute',top:5,right:5}}>
                                    <RemoveSvg/>
                                </div>
                            </div>}
                        </div>
                    }
                </div>
            )}
            <div className='flex flex-row'>
                <div
                    onClick={()=>{if(props.onEdit)props.onEdit('contents',[...(data?.contents||[]),{type:'閱讀文章內容(左對齊)',text:'',id:Date.now()}])}}
                    className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                    style={{ border: '1px solid #1F4CC8' }}
                >
                    <AddSvg /> 添加內容
                </div>
            </div>

            <div className='font-[700] mt-[64px]'>總預覽</div>
            <div className='w-full flex flex-col' style={{backgroundImage:data.bg_url?'url('+data.bg_url+')':'',backgroundSize:'cover',backgroundPosition:'center',backgroundRepeat:'no-repeat',minHeight:500,position:'relative'}}>
            {data?.contents?.map((item,index)=>
                <div key={index} className='w-full flex flex-col rounded-[7px] gap-[8px]' style={item?.isCustom?(item?.customStyle||{}):{}}>
                    {item?.type?.includes('文章標題')&&<div className='flex flex-col w-full gap-[8px]'>
                        <div className={`px-[16px] font-[700]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:item.type==='文章標題(左對齊)'?'left':item.type==='文章標題(居中對齊)'?'center':'right'}}>
                            <MDEditor.Markdown wrapperElement={{"data-color-mode": "light"}} source={item?.text||''} style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent",fontSize:32}} />
                        </div>
                    </div>}
                    {item?.type?.includes('閱讀文章內容')&&<div className='flex flex-col w-full gap-[8px]'>
                        <div className={`px-[16px]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:item.type==='閱讀文章內容(左對齊)'?'left':item.type==='閱讀文章內容(居中對齊)'?'center':'right'}}>
                            <MDEditor.Markdown wrapperElement={{"data-color-mode": "light"}} source={item?.text||''} style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent", fontSize:20}} />
                        </div>
                    </div>}
                    {item?.type==='圖片'&&
                        <div className='w-full flex flex-col'>
                             {item?.photo&&<div className='relative w-full flex flex-row justify-center p-[16px]' style={{backgroundColor:item?.backgroundColor||'white'}}>
                                {
                                    item?.photo
                                    ?<img style={{height:400,width:400,objectFit:'contain',maxWidth:'100%'}} src={item?.photo} alt='image'/>
                                    :<div></div>
                                }
                            </div>}
                        </div>
                    }
                    {item.type==='超連結'&&<div className='flex flex-col w-full gap-[8px]'>
                        <div className={`px-[16px]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:'left'}}>
                            <div cl style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent", fontSize:20}}>
                                <div className='inline' dangerouslySetInnerHTML={{__html: (item.redirects?.[0]?item?.text?.slice(0,item.redirects?.[0]?.start):item?.text)||'' }}/>
                                {item.redirects?.sort( (a,b)=> (a.start>b.start)?1:(a.start<b.start)?-1:0
                                )?.map((r,ri)=>
                                    <div className='inline' key={ri}>
                                        <div className='inline text-[blue] cursor-pointer underline' dangerouslySetInnerHTML={{__html: item?.text.slice(r.start,r.end)}}/>
                                        <div className='inline' dangerouslySetInnerHTML={{__html: 
                                            item.redirects?.[ri+1]?
                                            item?.text.slice(r.end,item.redirects?.[ri+1].start)
                                            :item?.text.slice(r.end)
                                        }}/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>}
                    {item.type==='彈出視窗'&&<div className='flex flex-col w-full gap-[8px]'>
                        <div className={`px-[16px]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:'left'}}>
                            <div cl style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent", fontSize:20}}>
                                <div className='inline' dangerouslySetInnerHTML={{__html: (item.popups?.[0]?item?.text?.slice(0,item.popups?.[0]?.start):item?.text)||'' }}/>
                                {item.popups?.sort( (a,b)=> (a.start>b.start)?1:(a.start<b.start)?-1:0
                                )?.map((r,ri)=>
                                    <div className='inline' key={ri}>
                                        <div className='inline text-[blue] cursor-pointer' style={{textDecoration:item.noUnderline?'none':'underline'}} onClick={()=>{setisShowPopup(r.text)}} dangerouslySetInnerHTML={{__html: item?.text.slice(r.start,r.end)}}/>
                                        <div className='inline' dangerouslySetInnerHTML={{__html: 
                                            item.popups?.[ri+1]?
                                            item?.text.slice(r.end,item.redipopupsrects?.[ri+1].start)
                                            :item?.text.slice(r.end)
                                        }}/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>}
                    {item.type==='彈出視窗-SP1'&&<div className='flex flex-col w-full gap-[8px]'>
                        <div className={`px-[16px]`} style={{backgroundColor:item?.backgroundColor||'white',textAlign:'left'}}>
                            <div cl style={{ whiteSpace: 'pre-wrap',color:item.color||"black",backgroundColor:"transparent", fontSize:20}}>
                                <div className='inline' dangerouslySetInnerHTML={{__html: (item.popups?.[0]?item?.text?.slice(0,item.popups?.[0]?.start):item?.text)||'' }}/>
                                {item.popups?.sort( (a,b)=> (a.start>b.start)?1:(a.start<b.start)?-1:0
                                )?.map((r,ri)=>
                                    <div className='inline' key={ri}>
                                        <div className='inline text-[blue] cursor-pointer' style={{textDecoration:item.noUnderline?'none':'underline'}} onClick={()=>{setisShowPopup(r.text)}} dangerouslySetInnerHTML={{__html: item?.text.slice(r.start,r.end)}}/>
                                        <div className='inline' dangerouslySetInnerHTML={{__html: 
                                            item.popups?.[ri+1]?
                                            item?.text.slice(r.end,item.redipopupsrects?.[ri+1].start)
                                            :item?.text.slice(r.end)
                                        }}/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>}
                </div>
            )}
            </div>
        </div>
        {isShowPopup&&<PopupWindow text={isShowPopup} onClose={()=>{setisShowPopup(false)}}/>}

        {isLoading&&<LoadingPage/>}
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  